import { render, staticRenderFns } from "./ConstituicaoEstadual.vue?vue&type=template&id=4ec18374&scoped=true"
import script from "./ConstituicaoEstadual.vue?vue&type=script&lang=js"
export * from "./ConstituicaoEstadual.vue?vue&type=script&lang=js"
import style0 from "./ConstituicaoEstadual.vue?vue&type=style&index=0&id=4ec18374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec18374",
  null
  
)

export default component.exports